module.exports = __webpack_public_path__ + "img/roshan.81a00b76.png";